import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";
import { Breadcrumb } from "./Breadcrumb";
import { ToolActions, TranscriptButton } from "./ToolActions";
import { EVMProvider } from "@/context/EVMContext";

interface SecondaryHeaderProps {
  className?: string;
}

export function SecondaryHeader({ className }: SecondaryHeaderProps) {
  const location = useLocation();
  const toolPath = location.pathname.split("/")[1];

  // Check if the current page is a tool page
  const isToolPage = ["cvr", "evm", "target-cost", "whatsapp-analyzer"].includes(toolPath);

  if (!isToolPage) return null;

  const renderActions = () => {
    if (toolPath === "evm") {
      return (
        <EVMProvider>
          <ToolActions toolType={toolPath} />
        </EVMProvider>
      );
    }
    return <ToolActions toolType={toolPath} />;
  };

  return (
    <div
      className={cn(
        "sticky top-10 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60", // Adjusted top value
        className
      )}
    >
      <div className="w-full">
        <div className="flex h-10 items-center justify-between">
          <Breadcrumb />
          <div className="flex items-center gap-2">
            {toolPath === 'whatsapp-analyzer' && <TranscriptButton />}
            {renderActions()}
          </div>
        </div>
      </div>
    </div>
  );
}
